import React, { useState } from "react";
import logo from "../assets/images/logo.png";
import division1 from "../assets/images/division-1.png";
import division2 from "../assets/images/division-2.png";
import division3 from "../assets/images/division-3.png";
import division4 from "../assets/images/division-4.png";
import { Link } from "react-router-dom";

function Divisions() {
const [activeTab, setActiveTab] = useState(0);

  return (
    <section id="actu-all-divisions-wrapper">
      <div className="container">
        <h2>
          <div className="inner-logo">
            <img src={logo} alt="Logo" />
          </div>
          Divisions
        </h2>

        <div className="actu-all-box-wrapper">
      <div className="actu-all-box analyse">
        <Link to="/products" state={{ activeTab: 1 }} className={`tab ${activeTab === 1 ? "active" : ""}`}>
  <h3> Analyse.</h3>
  <div className="division-img">
    <img src={division1} alt="Divisions" />
  </div>
  <p>Laboratory &amp; Specialty chemicals</p>
  </Link>
</div>

<div className="actu-all-box aqua">
  <Link to="/products" state={{ activeTab: 2 }} className={`tab ${activeTab === 2 ? "active" : ""}`}>
  <h3>Aqua.</h3>
  <div className="division-img">
     <img src={division2} alt="Divisions" />
  </div>
  <p>Water Chemistry &amp; Analytical solutions</p>
  </Link>
</div>

<div className="actu-all-box accurate">
  <Link to="/products" state={{ activeTab: 3 }} className={`tab ${activeTab === 3 ? "active" : ""}`}>
  <h3>Accurate.</h3>
  <div className="division-img">
     <img src={division3} alt="Divisions" />
  </div>
  <p>Custom-made solutions</p>
  </Link>
</div>

<div className="actu-all-box again">
  <Link to="/products" state={{ activeTab: 4 }} className={`tab ${activeTab === 4 ? "active" : ""}`}>
  <h3>Again.</h3>
  <div className="division-img">
     <img src={division4} alt="Divisions" />
  </div>
  <p>Recycle. Re-use. Reduce</p>
  </Link>
</div>

        </div>
      </div>
    </section>
  );
}

export default Divisions;
